package com.xtream.data_kmp.util.extension


import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.util.exception.GeneralException
import com.xtream.data_kmp.util.exception.UserNotFoundException
import io.ktor.client.network.sockets.SocketTimeoutException
import io.ktor.serialization.JsonConvertException
import kotlinx.io.IOException

fun Throwable.getErrorMessage(isTimeValid: Boolean = true): String {
    return when (this) {
        is SocketTimeoutException -> AllConst.SOCKET_TIMEOUT_EXCEPTION
        is IOException -> AllConst.IO_EXCEPTION
        is UserNotFoundException -> AllConst.USER_NOT_FOUND_EXCEPTION
        is JsonConvertException -> AllConst.JSON_CONVERT_EXCEPTION
        is GeneralException -> this.message.toString()
        else -> this.message.toString()
    }
}